import { useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const signIn = useAuthStore((state) => state.signIn);
  const isLoading = useAuthStore((state) => state.isLoading);
  const error = useAuthStore((state) => state.error);
  const clearError = useAuthStore((state) => state.clearError);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const redirectPath =
    (location.state as { from?: string } | null)?.from ?? '/reviews/pending';

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clearError();

    try {
      await signIn(email, password);
      navigate(redirectPath, { replace: true });
    } catch {
      // エラーはstore側で管理
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-admin-ink">管理者ログイン</h2>
      <p className="mt-2 text-sm text-admin-muted">
        adminsコレクションに登録されたアカウントのみログインできます。
      </p>

      <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
        <div>
          <label className="mb-1 block text-sm font-medium text-admin-ink" htmlFor="email">
            メールアドレス
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="w-full rounded-xl border border-admin-border bg-white px-3 py-2.5 text-sm shadow-sm outline-none transition focus:border-admin-accent"
            placeholder="admin@kulum.jp"
            autoComplete="email"
            required
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-admin-ink" htmlFor="password">
            パスワード
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="w-full rounded-xl border border-admin-border bg-white px-3 py-2.5 text-sm shadow-sm outline-none transition focus:border-admin-accent"
            placeholder="パスワード"
            autoComplete="current-password"
            required
          />
        </div>

        {error && (
          <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={isLoading}
          className="w-full rounded-xl bg-admin-accent px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-admin-accent-strong disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isLoading ? 'ログイン中...' : 'ログイン'}
        </button>
      </form>
    </div>
  );
}
